module.exports = __webpack_public_path__ + "img/markergreen.39d3d994.svg";